import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface HamburgerOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}
export function HamburgerOverlay({
  isOpen,
  onClose
}: HamburgerOverlayProps) {
  // Lock body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 bg-[rgba(42,42,42,0.98)] flex flex-col items-center justify-center animate-fade-in" data-id="element-105">
      {/* Close Button */}
      <button onClick={onClose} className="absolute top-6 right-6 md:top-12 md:right-12 p-2 text-gold hover:text-white transition-colors duration-300 focus:outline-none" aria-label="Close Menu" data-id="element-106">
        <XIcon className="w-10 h-10 md:w-12 md:h-12" data-id="element-107" />
      </button>

      {/* Navigation Links */}
      <nav className="flex flex-col items-center space-y-10 md:space-y-16 mb-16" data-id="element-108">
        {['Wines', 'About', 'Sustainability', 'Contact'].map((item, index) => <a key={item} href={`#${item.toLowerCase()}`} onClick={onClose} className="text-4xl md:text-6xl font-semibold text-gold uppercase tracking-widest transition-all duration-500 hover:scale-105 hover:brightness-125 hover:text-white opacity-0 animate-slide-up" style={{
        animationDelay: `${index * 0.1}s`,
        animationFillMode: 'forwards'
      }} data-id="element-109">
            {item}
          </a>)}
      </nav>

      {/* Wine Range Showcase (Bottom) */}
      <div className="absolute bottom-12 left-0 right-0 flex justify-center space-x-8 md:space-x-16 px-4" data-id="element-110">
        {['BLOCK', 'ESTATE', 'GO'].map((label, index) => <div key={label} className="flex flex-col items-center opacity-0 animate-slide-up" style={{
        animationDelay: `${0.4 + index * 0.1}s`,
        animationFillMode: 'forwards'
      }} data-id="element-111">
            {/* Placeholder for bottle image */}
            <div className="h-32 w-8 md:h-48 md:w-12 bg-gradient-to-b from-transparent to-black/50 border border-white/10 mb-4 rounded-t-full relative overflow-hidden group cursor-pointer" data-id="element-112">
              <div className="absolute inset-0 bg-chocolate/40 group-hover:bg-gold/20 transition-colors duration-500" data-id="element-113"></div>
            </div>
            <span className="text-xs md:text-sm text-gold tracking-widest uppercase opacity-60" data-id="element-114">
              {label}
            </span>
          </div>)}
      </div>
    </div>;
}